<template>
  <div>
    <div class="loading-state-container" v-if="loadScheduleState.isLoading">
      <div class="container">
        <PreloaderSection />
      </div>
    </div>
    <div v-if="!loadScheduleState.isLoading">
      <router-view v-if="!loadScheduleState.error" :scheduleData="schedule" />
      <ErrorMessageMonthlyScheduleContainer
        v-if="loadScheduleState.error"
        :error="loadScheduleState.error"
        redirectLink="/schedules-monthly"
      />
    </div>
  </div>
</template>

<script>
import PreloaderSection from '@/components/PreloaderSection.vue';
import { loadScheduleById } from './api';
import ErrorMessageMonthlyScheduleContainer from './ErrorMessageMonthlyScheduleContainer.vue';

export default {
  components: {
    PreloaderSection,
    ErrorMessageMonthlyScheduleContainer,
  },
  data() {
    return {
      schedule: {
        name: null,
      },
      loadScheduleState: {
        isLoading: false,
        error: null,
      },
    };
  },
  created() {
    this.load(this.scheduleId);
  },
  computed: {
    scheduleId() {
      return this.$route.params.scheduleId;
    },
  },
  methods: {
    async load(scheduleId) {
      this.loadScheduleState.isLoading = true;
      try {
        const response = await loadScheduleById(scheduleId);
        this.schedule = response.data;
        this.loadScheduleState.isLoading = false;
      } catch (error) {
        this.loadScheduleState.error = error.response;
        this.loadScheduleState.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.loading-state-container {
  margin-top: $spacer * 6;
}
</style>
